var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-icon",domProps:{"innerHTML":_vm._s(require(("!html-loader!@/assets/icons/" + _vm.name + ".svg")))}})}
var staticRenderFns = []

export { render, staticRenderFns }